import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { SubjectRelay } from '../../../../shared/commands/subject-relay.class';
import { ParcService } from '../services/parc.service';
import { NotificationMeteoGroupee, ResumeIndicateur } from '../entities/notification-meteo-groupee.entity';

import { UserService } from '../../../humain/user/services/user.service';
import { UserTLR } from '../../../humain/user/entities/user-tlr.entity';

@Component({
	selector: 'notif-meteo',
	templateUrl: 'notif-meteo.html',
	styleUrls: ['notif-meteo.css'],
})
export class NotificationMeteoComponent {

	sortedMetasNotifications: NotificationMeteoGroupee[] = [];
	private resfreshDataCommands = new SubjectRelay();

	private user!: UserTLR;

	@Input() set refreshCommands(obs: Observable<void> | null) {
		this.resfreshDataCommands.registerSource(obs);
	}

	@Output() stateTransitionNeeded = new EventEmitter<void>();

	constructor(
		@Inject(ParcService) private parcService: ParcService,
		@Inject(UserService) private userService: UserService
	) {
		userService.getCurrentUserTLR().subscribe(
			(user) => {
				this.user = user;
				this.loadNotifications();
			}
		);
		this.resfreshDataCommands.asObservable().subscribe(() => {
			this.loadNotifications();
		});
	}

	private loadNotifications(): void {
		if (this.user) {
			this.parcService.getMeteoNotifEvents(this.user.id).subscribe(
				(map: Record<number, NotificationMeteoGroupee>) => {
					this.sortedMetasNotifications = this.filtrerNotifications(map);
				}
			);
		}
	}

	masquer(notification: NotificationMeteoGroupee): void {
		const ids = notification.notificationIds || [];
		if (ids.length === 0) {
			console.error('Notification météo sans ids', notification);
			return;
		}

		this.sortedMetasNotifications = this.sortedMetasNotifications
			.filter(n => n.parcId !== notification.parcId);

		this.parcService.markMeteoNotifsAsViewed(ids)
			.subscribe((map: Record<number, NotificationMeteoGroupee>) => {
				this.sortedMetasNotifications = this.filtrerNotifications(map);
			});
	}

	trackByParc = (_: number, n: NotificationMeteoGroupee) => n.parcId;

	private filtrerNotifications(map: Record<number, NotificationMeteoGroupee>): NotificationMeteoGroupee[] {
		return Object.values(map || {})
			.map(groupe => ({
				...groupe,
				indicateurs: (groupe.indicateurs || []).filter(
					(ind: ResumeIndicateur) => this.estDegradationAlertable(ind.nouveauNiveau)
				)
			}))
			.filter(groupe => groupe.indicateurs.length > 0);
	}

	private estDegradationAlertable(nouveauNiveau: string): boolean {
		const nouveau = (nouveauNiveau || '').trim().toUpperCase();
		return nouveau === 'ORANGE' || nouveau === 'ROUGE' || nouveau === 'NOIR';
	}

	niveauClass(niveau: string): string {
		switch ((niveau || '').trim().toUpperCase()) {
			case 'VERT':
				return 'niveau-vert';
			case 'JAUNE':
				return 'niveau-jaune';
			case 'ORANGE':
				return 'niveau-orange';
			case 'ROUGE':
				return 'niveau-rouge';
			case 'NOIR':
				return 'niveau-noir';
			default:
				return '';
		}
	}
}